import { render, staticRenderFns } from "./mainCarousel.vue?vue&type=template&id=5e17d6cc&scoped=true&"
import script from "./mainCarousel.vue?vue&type=script&lang=js&"
export * from "./mainCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e17d6cc",
  null
  
)

export default component.exports